import { ChangeDetectionStrategy, Component, computed, input, isDevMode } from '@angular/core';
import { SOLAR_DEFAULT_VARIANT } from '../../../icons/generated/solar-icon-names';
import { IconNameModel } from './models/icon-name.model';
import { IconSizeModel } from './models/icon-size.model';
import { resolveIconHref } from './utils/resolve-icon-href';

@Component({
  selector: 'shared-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  readonly icon = input.required<IconNameModel>();
  readonly width = input<string | undefined>(undefined);
  readonly height = input<string | undefined>(undefined);
  readonly fill = input('');
  readonly stroke = input('');
  readonly color = input('');
  readonly size = input<IconSizeModel>('medium');

  protected readonly href = computed<string>(() => {
    const icon = this.icon();
    const href = resolveIconHref(icon);

    if (!href && icon && isDevMode()) {
      console.warn(
        `[shared-icon] Unknown icon "${icon}". A bare name resolves to the "${SOLAR_DEFAULT_VARIANT}" style; any other style is part of the name (e.g. "alt-arrow-down-linear"). Add it to libs/shared-ui/src/icons/icons.config.ts and run \`npm run generate-icons\`.`,
      );
    }

    return href;
  });
}
